import comp from "./OutLine";
export default comp;
